/* src/app/modules_v2/finance/cash/components/cash-detail-panel/cash-detail-panel.component.css */
:host {
  display: block;
}
.cd-panel {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) minmax(0, 1.6fr);
  gap: 16px;
}
.cd-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 0;
}
.cd-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.cd-card__title,
.cd-block__title,
.cd-line__label {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.cd-card__title {
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
}
.cd-card__title mat-icon,
.cd-block__title mat-icon,
.cd-line__label mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
  flex-shrink: 0;
}
.cd-card__hint {
  font-size: 12px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.cd-card__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}
.cd-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.cd-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  background: #f4f6f8;
  border-radius: 8px;
  min-width: 0;
}
.cd-kpi--accent {
  background: #fbfee8;
  border: 1px solid #e5f3a0;
}
.cd-kpi__label {
  font-size: 11px;
  color: #6b7280;
}
.cd-kpi__value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.cd-kpi__value--negative {
  color: #dc2626;
}
.cd-lines {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  border: 1px solid #eef1f4;
  border-radius: 8px;
  overflow: hidden;
}
.cd-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 12px;
  font-size: 13px;
  color: #2f3540;
}
.cd-line + .cd-line {
  border-top: 1px solid #eef1f4;
}
.cd-line__value {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.cd-block {
  padding: 10px 0;
}
.cd-block + .cd-block {
  border-top: 1px solid #eef1f4;
}
.cd-block__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}
.cd-block__title {
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
}
.cd-block__meta {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.cd-block__meta strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.cd-rows {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cd-row {
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  padding: 6px 6px 6px 10px;
  background: #f9fafb;
  border: 1px solid #eef1f4;
  border-radius: 6px;
  font-size: 13px;
}
.cd-row__date {
  color: #6b7280;
  white-space: nowrap;
}
.cd-row__main {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}
.cd-row__concept {
  color: #2f3540;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.cd-row__meta {
  font-size: 12px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex-shrink: 1;
}
.cd-row__amount {
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.cd-block__empty {
  padding: 6px 10px;
  font-size: 12px;
  color: #9ca3af;
  border: 1px dashed #e5e7eb;
  border-radius: 6px;
}
.cd-block__side {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.cd-add.cf-btn.mat-mdc-button-base {
  height: 28px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
}
.cd-add.cf-btn.mat-mdc-button-base .mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  margin-right: 2px !important;
}
.cd-row:hover {
  background: #fff;
  border-color: #e5e7eb;
}
.cd-row__actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.cd-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.cd-icon-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.cd-icon-btn:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.cd-icon-btn--danger:hover {
  background: #fef2f2;
  color: #dc2626;
}
.cd-more {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 2px;
  margin-top: 2px;
  padding: 2px 6px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  cursor: pointer;
}
.cd-more mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.cd-more:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.cd-empty {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.cd-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.cd-empty--error > mat-icon {
  color: #dc2626;
}
@media (max-width: 900px) {
  .cd-panel {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .cd-kpis {
    grid-template-columns: 1fr;
  }
  .cd-row {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .cd-row__date {
    grid-column: 1 / -1;
    font-size: 12px;
  }
  .cd-row__main {
    flex-direction: column;
    gap: 0;
  }
}
/*# sourceMappingURL=cash-detail-panel.component.css.map */
